<div class="container-box shadow-none p-3">
  <mat-form-field2>
    <mat-label i18n>Enter Booking.com Entity ID</mat-label>
    <input type="text" matInput [formControl]="legalEntityIdCtrl" placeholder="Entity ID" i18n-placeholder required />
    <mat-error *ngIf="legalEntityIdCtrl.touched && legalEntityIdCtrl.hasError('required')">
      <ng-container i18n>Entity ID is required</ng-container>
    </mat-error>
  </mat-form-field2>

  <div class="text-muted mb-3 text-center">OR</div>

  <app-user-select
    [multiple]="false"
    [ctrl]="userCtrl"
    (selected)="onUserSelect($event)"
    label="Select a user to create an Entity ID"
    i18n-label
    placeholder="Select User"
    i18n-placeholder
  ></app-user-select>
  <ng-container *ngIf="userCtrl.value">
    <ng-container *ngTemplateOutlet="entityInfoFormTmpl"></ng-container>
  </ng-container>
</div>

<div class="mt-3 d-flex align-items-center justify-content-between">
  <div></div>
  <button
    class="btn btn-secondary-info"
    [disabled]="isLoading"
    (click)="onSave()"
    matTooltip="You can’t return to this screen after clicking Next."
    i18n-matTooltip
  >
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs" *ngIf="!isLoading"></i>
    <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
  </button>
</div>

<ng-template #entityInfoFormTmpl>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the commercial name of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Company Name</mat-label>
          <input matInput type="text" formControlName="company_name" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the website of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Website</mat-label>
          <input matInput type="url" formControlName="website" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the legal name of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Legal Name</mat-label>
          <input matInput type="text" formControlName="legal_name" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <app-language-select
          [items]="languages"
          [ctrl]="form.get('preferred_language')"
          [showBlankItem]="false"
          matTooltip="Specifies the preferred language in which the Accommodation Partner wants to communicate."
          i18n-matTooltip
        ></app-language-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the legal contact name of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Legal Contact Name</mat-label>
          <input matInput type="text" formControlName="legal_contact_name" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the legal contact email of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Legal Contact Email</mat-label>
          <input matInput type="email" formControlName="legal_contact_email" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the legal contact phone number of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Legal Contact Phone Number</mat-label>
          <input matInput type="text" formControlName="legal_contact_phone_number" />
        </mat-form-field2>
      </div>
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <app-country-select
          [codeCtrl]="form.get('country')"
          matTooltip="Specifies the country of the Accommodation Partner company."
          i18n-matTooltip
        ></app-country-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the city of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>City</mat-label>
          <input matInput type="text" formControlName="city" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the zipcode of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Zip</mat-label>
          <input matInput type="text" formControlName="zipcode" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the street of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Street</mat-label>
          <input matInput type="text" formControlName="street" />
        </mat-form-field2>
      </div>
      <div class="col-md-12"></div>
      <div class="col-md-6">
        <mat-form-field2
          class="mat-block"
          matTooltip="Specifies the total number of properties of the Accommodation Partner company."
          i18n-matTooltip
        >
          <mat-label i18n>Total Number of Properties</mat-label>
          <input matInput type="number" formControlName="total_number_of_properties" />
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <app-country-select
          [codeCtrl]="form.get('contract_countries')"
          matTooltip="Specifies the countries in which the Accommodation Partner has properties."
          i18n-matTooltip
          label="Contract Countries"
          [multiple]="true"
          [showBlankItem]="false"
        ></app-country-select>
      </div>
    </div>
  </form>
</ng-template>
